import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';

import css from './index.scss';

import { RETIRED_COURSE_ID } from '../../../constants';

import Button from '../../button';
import getTranslations from '../translations';

const Footer = ({
    enablePublish,
    enableSaveCourse,
    genericCourse,
    intl,
    isEditing,
    onClickBackButton,
    saveCourse,
    showPublishModal
}) => {
    /**
     * TRANSLATIONS
     */
    const {
        backButtonText,
        publishButtonText,
        saveCourseButtonText
    } = getTranslations({ intl });

    /**
     * VARIABLES
     */
    const genericCourseState = Number(genericCourse.status);
    const isRetiredCourse = genericCourseState === RETIRED_COURSE_ID;
    const isPublishButtonDisabled = !enablePublish || isRetiredCourse;

    /**
     * FUNCTION
     */
    const renderSavePanel = () => {
        if (isRetiredCourse && isEditing) return false;

        return (
            <Fragment>
                <Button
                    disabled={!enableSaveCourse}
                    handleOnClick={saveCourse}
                    label={saveCourseButtonText}
                    primary
                />
                <Button
                    disabled={isPublishButtonDisabled}
                    handleOnClick={() => showPublishModal(true)}
                    label={publishButtonText}
                    primary
                />
            </Fragment>
        );
    };

    return (
        <div className={css.footer}>
            <div className={css.backPanel}>
                <Button
                    handleOnClick={onClickBackButton}
                    label={backButtonText}
                    primary
                />
            </div>
            <div className={css.savePanel}>
                {renderSavePanel()}
            </div>
        </div>
    );
};

Footer.propTypes = {
    enablePublish: PropTypes.bool,
    enableSaveCourse: PropTypes.bool,
    genericCourse: PropTypes.object,
    intl: intlShape.isRequired,
    isEditing: PropTypes.bool,
    onClickBackButton: PropTypes.func,
    saveCourse: PropTypes.func,
    showPublishModal: PropTypes.func
};

export default styleable(css)(injectIntl(Footer));



// WEBPACK FOOTER //
// ./app/components/course-creator/footer/index.js